"use strict";

import fetch from '@/utils/fetch';

/**
 * hyy 导出文件下载
 * @param query
 */
 export function expFile(query) {
  return fetch({
      url: 'export/export/expFile',
      method: 'post',
      data: query,
      responseType: 'blob'
  });
}




// WEBPACK FOOTER //
// ./src/api/export.js